// frontend/smartdocs-admin/src/components/settings/SecuritySettings.tsx
import React from 'react';
import { useSettings } from '@/context/SettingsContext';
import ToggleSwitch from '@shared/ToggleSwitch';
import SliderInput from '@shared/SliderInput';
import SettingsPage from "@/pages/SettingsPage";
import Card from "@shared/Card";

const SecuritySettings: React.FC = () => {
  const { settings, updateSetting, loading } = useSettings();

  const securitySettings = settings.Security || {};

  const handleUpdate = (key: string, value: any) => {
    updateSetting('Security', key, value);
  };

  return (
    <SettingsPage>
      <Card>
        <div className="space-y-6">
      {/*<h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Security Settings</h2>*/}

      {/* Enable Two-Factor Authentication (2FA) */}
      <div className="flex items-center justify-between">
        <div>
          <label htmlFor="enableTwoFactorAuth" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Enable Two-Factor Authentication (2FA)</label>
          <p className="text-sm text-gray-500 dark:text-gray-400">Add an extra layer of security for user logins.</p>
        </div>
        <ToggleSwitch
          id="enableTwoFactorAuth"
          label=""
          checked={securitySettings.enableTwoFactorAuth || false}
          onChange={(e) => handleUpdate('enableTwoFactorAuth', e.target.checked)}
          disabled={loading}
        />
      </div>

      {/* Session Timeout */}
      <div>
        <label htmlFor="sessionTimeout" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Session Timeout (minutes)</label>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Automatically log out inactive users after a specified period.</p>
        <SliderInput
          id="sessionTimeout"
          label=""
          min={15}
          max={240}
          step={15}
          value={securitySettings.sessionTimeout || 60}
          onChange={(value) => handleUpdate('sessionTimeout', value)}
          disabled={loading}
        />
      </div>

      {/* Password Policy: Minimum Length */}
      <div>
        <label htmlFor="minPasswordLength" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Minimum Password Length</label>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Set the minimum number of characters required for user passwords.</p>
        <SliderInput
          id="minPasswordLength"
          label=""
          min={8}
          max={20}
          step={1}
          value={securitySettings.minPasswordLength || 8}
          onChange={(value) => handleUpdate('minPasswordLength', value)}
          disabled={loading}
        />
      </div>

      {/* Password Policy: Require Special Characters */}
      <div className="flex items-center justify-between">
        <div>
          <label htmlFor="requireSpecialChars" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Require Special Characters</label>
          <p className="text-sm text-gray-500 dark:text-gray-400">Enforce the inclusion of special characters in user passwords.</p>
        </div>
        <ToggleSwitch
          id="requireSpecialChars"
          label=""
          checked={securitySettings.requireSpecialChars || false}
          onChange={(e) => handleUpdate('requireSpecialChars', e.target.checked)}
          disabled={loading}
        />
      </div>

      {/* Account Lockout Threshold */}
      <div>
        <label htmlFor="accountLockoutThreshold" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Account Lockout Threshold</label>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Number of failed login attempts before an account is locked.</p>
        <SliderInput
          id="accountLockoutThreshold"
          label=""
          min={3}
          max={10}
          step={1}
          value={securitySettings.accountLockoutThreshold || 5}
          onChange={(value) => handleUpdate('accountLockoutThreshold', value)}
          disabled={loading}
        />
      </div>
    </div>
      </Card>
    </SettingsPage>
  );
};

export default SecuritySettings;
